<aside class="sidebar-sec" [ngClass]="{'collapsed': isCollapsed}">
    <div class="sidelogoss">
        <img *ngIf="!isCollapsed" [src]="bucketurl + '/images/suzuki_logo.png'" style="width:60%;margin-left: 35px;"
            alt="" />
        <img *ngIf="isCollapsed" [src]="bucketurl + '/images/suzuki_s.png'" style="width:30%;margin-left: 10px;"
            alt="" />
        <!-- <img style="width:20px;margin-right: 10px;cursor: pointer;" [src]="bucketurl + '/menu/menu_unfold.png'" alt=""
            (click)="toggleSidebar()" /> -->
    </div>
    <hr style="opacity: .25 !important;border-top: 1px #8f8f8f solid;">
    <div class="search-menu ml-2" style="width: 190px;margin-bottom: -20px;">
        <input class="form-control menuser" (keyup)="applyFilter($event)" type="text" placeholder="Search Menu" />
        <span class="menu_searchicon"><i class="fa fa-search"></i></span>
    </div>
    <div class="sidebar-scroll">
        <ul class="sidebar-menu">
            <li class="main-menu has-collapsible" *ngFor="let item of filteredMenuItems">
                <a class="crts" [routerLink]="item.subMenuItems.length === 0 ? item.link : null"
                    routerLinkActive="active" [title]="item.title" [id]="item.id"
                    [class.active]="selectedTarget === item.id" (click)="toggleSubMenu(item.id)">
                    <span>
                        <img style="margin-left: 5px;"
                            [src]="bucketurl + '/menu/' + (selectedTarget === item.id ? item.selectedImg : item.img) + '.png'"
                            alt="" class="menu-img">
                    </span>
                    <span class="side-font">{{ item.title }}</span>
                    <i *ngIf="item.subMenuItems.length > 0" class="fa"
                        [ngClass]="{'fa-chevron-down': selectedTarget !== item.id, 'fa-chevron-up': selectedTarget === item.id}"></i>
                </a>
                <ul class="sub-menu" *ngIf="selectedTarget === item.id && item.subMenuItems.length > 0">
                    <li class="main-menu" *ngFor="let subItem of item.subMenuItems">
                        <a [routerLink]="subItem.link" routerLinkActive="active"><span
                                class="side-font">{{subItem.title}}</span></a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</aside>